import { InfiniteScrollV2 } from '@/components/atoms/InfiniteScrollV2'
import { RcTrans } from '@/components/atoms/RcTrans'
import { SearchBox } from '@/components/molecules/input/SearchBox'
import { NoResults } from '@/components/molecules/text/NoResults'
import { RcTableResults } from '@/components/molecules/text/RcTableResults'
import { useCompetitionTeamDocument } from '@/entity/competition-team/useCompetitionTeamDocument'
import { useCompetition } from '@/entity/competition/useCompetition'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import { CompetitionState } from '@rallycry/api-suite-typescript/dist/models/CompetitionState'
import { isEmpty } from 'lodash-es'
import { useState } from 'react'
import { useDebounce } from 'use-debounce'
import {
  RcTable,
  RcTableBody,
  RcTableCell,
  RcTableContainer,
  RcTableHead,
  RcTableHeaderRow,
  RcTableStickyHeaderCell
} from '../../../../molecules/text/RcTable'
import { TeamsTableRow } from './TeamTableRow'

export const TeamsDisplay = () => {
  const [filter, setFilter] = useState('')
  const [debouncedFilter] = useDebounce(filter, 300)

  const { competition, isSoloCompetition } = useCompetition()

  const competitionTeams = useCompetitionTeamDocument({
    request: {
      q: debouncedFilter,
      competitionId: competition?.id ? [competition?.id!] : undefined,
      sort:
        competition?.state === CompetitionState.CONCLUDED ? ['rank'] : ['seed']
    }
  })

  const { teams, totalElements, hasMore, query } = competitionTeams
  const { isValidating, size, setSize } = query

  return (
    <>
      <Paper
        sx={theme => ({
          pt: 5,
          px: { xs: 3, sm: 4 },
          zIndex: theme.zIndex.appBar
        })}
      >
        <RcTableResults
          total={totalElements}
          align='flex-start'
          sx={{ pb: 2 }}
        />

        <SearchBox filter={filter} setFilter={setFilter} />
      </Paper>

      <Box minHeight={100} py={3}>
        {!isValidating && isEmpty(teams) ? (
          <NoResults />
        ) : (
          <RcTableContainer headerHeight={130}>
            <RcTable>
              <RcTableHead>
                <RcTableHeaderRow>
                  <RcTableStickyHeaderCell>
                    <Typography
                      variant='subtitle1'
                      color='text.secondary'
                      noWrap
                      pl={5}
                    >
                      <RcTrans i18nKey='competition:teams.header.teams' />
                    </Typography>
                  </RcTableStickyHeaderCell>
                  <RcTableCell />
                  {isSoloCompetition ? null : (
                    <RcTableCell>
                      <Typography
                        variant='subtitle1'
                        color='text.secondary'
                        noWrap
                      >
                        <RcTrans i18nKey='competition:teams.header.member-count' />
                      </Typography>
                    </RcTableCell>
                  )}
                  <RcTableCell></RcTableCell>
                </RcTableHeaderRow>
              </RcTableHead>
              <RcTableBody>
                {teams?.map(it => <TeamsTableRow key={it.id} team={it} />)}
              </RcTableBody>
            </RcTable>
          </RcTableContainer>
        )}
        <InfiniteScrollV2
          hasMore={hasMore}
          isLoading={isValidating}
          onLoad={() => setSize(size + 1)}
        />
      </Box>
    </>
  )
}
